import { Link } from "react-router-dom";

import TikTokIcon from "@/assets/tiktok";
import { Button } from "@/components/ui/button";

import type { TikTokBlock } from "./tiktokFormat";

/** The full-tab state when TikTok cannot serve a feature yet, and what to do about it. */
export function TikTokBlockedState({
  block,
  feature,
  onRetry,
}: {
  block: TikTokBlock;
  /** e.g. "sample requests"; completes the sentences below. */
  feature: string;
  onRetry: () => void;
}) {
  const copy: Record<TikTokBlock["kind"], { title: string; body: string }> = {
    not_connected: {
      title: `Connect your TikTok Shop to manage ${feature}`,
      body: "Reveshare reads and answers them through your shop’s TikTok Shop connection.",
    },
    reconnect: {
      title: "Reconnect your TikTok Shop",
      body: `TikTok stopped accepting the connection. Reconnect it from Integrations to manage ${feature} again.`,
    },
    awaiting_approval: {
      title: `${feature[0].toUpperCase()}${feature.slice(1)} are waiting on TikTok`,
      body: "They unlock once TikTok approves Reveshare’s affiliate permissions. Reconnect your shop after approval to turn them on.",
    },
    error: { title: `${feature[0].toUpperCase()}${feature.slice(1)} could not load`, body: block.kind === "error" ? block.message : "" },
  };
  const { title, body } = copy[block.kind];
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center px-6 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-muted">
        <TikTokIcon className="h-7 w-7" />
      </div>
      <h2 className="text-lg font-semibold text-foreground">{title}</h2>
      <p className="mt-1 text-sm text-muted-foreground">{body}</p>
      <div className="mt-6">
        {block.kind === "error" ? (
          <Button type="button" variant="outline" onClick={onRetry}>
            Try again
          </Button>
        ) : (
          <Button asChild>
            <Link to="/brand/integrations">Go to Integrations</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
